import { Form } from 'react-bootstrap';

const Unidades = props => {
  const userUnidade = props.userUnidade; 

  return (
    <Form.Group controlId="formUnidade" className="mt-4">
      <Form.Label>*Unidade:</Form.Label>
      <Form.Control
        type="text"
        required
        name="formUnidade"
        onChange={e => props.handleUnidade(e)}
        value={userUnidade}
        readOnly
      />
    </Form.Group>
  );
};

export default Unidades;
